import React from 'react'
import MarqueeSection from '../components/common/Marquee'
import SkillContainer from '../components/containers/SkillContainer'
import ExpMarquee from '../components/common/ExpMarquee'
import WorkExperienceContainer from '../components/containers/WorkExperienceContainer'

function ExperienceSection({isNavigating}) {
  return (
    <section id="experience">
        <MarqueeSection/>
        <SkillContainer/>
        <ExpMarquee/>
        <WorkExperienceContainer isNavigating={isNavigating}/>
    </section>
  )
}

export default ExperienceSection